// extracted by mini-css-extract-plugin
export default {"main":"speak_main__zHj0R","image":"speak_image__tX47W","text":"speak_text__jl8BB","group":"speak_group__X29LY"};